import { render, staticRenderFns } from "./SurelyDeleteAccount.vue?vue&type=template&id=1c00ea0a"
import script from "./SurelyDeleteAccount.vue?vue&type=script&lang=js"
export * from "./SurelyDeleteAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports